import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { SendBackIhmsComponent } from '../components/send-back-ihms/send-back-ihms.component';

@Injectable({
  providedIn: 'root',
})
export class SendBackIhmsDialogService {
  constructor(private dialogService: DialogService) {}
  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: SendBackIhmsComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: SendBackIhmsComponent,
      height: 'auto',
      maxHeight: '90vh',
      width: '530px',
      cssClass: 'send-back-ihms-dialog',
    });
    const content: ComponentRef<SendBackIhmsComponent> =
      dialog.content as ComponentRef<SendBackIhmsComponent>;
    const instance: SendBackIhmsComponent = content.instance;
    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
